module.exports = __webpack_public_path__ + "img/table-not-found.e054504d.png";